const API_LOGGING_STORAGE_KEY = "API_LOGGING_ENABLED";

class ApiLoggerService {
  private isEnabled: boolean | null = null;

  private checkEnabled(): boolean {
    if (this.isEnabled !== null) {
      return this.isEnabled;
    }

    const isLocalhost =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

    const storageFlag = typeof localStorage !== "undefined" && localStorage.getItem(API_LOGGING_STORAGE_KEY) === "true";

    this.isEnabled = isLocalhost || storageFlag;
    return this.isEnabled;
  }

  public async wrap<T>(method: string, endpoint: string, fn: () => Promise<T>, data?: unknown): Promise<T> {
    this.log(method, endpoint, data);
    const start = Date.now();

    try {
      const result = await fn();
      this.logResponse(method, endpoint, result, Date.now() - start);
      return result;
    } catch (error) {
      this.logError(method, endpoint, error, Date.now() - start);
      throw error;
    }
  }

  public log(method: string, endpoint: string, data?: unknown): void {
    if (!this.checkEnabled()) return;

    const timestamp = new Date().toISOString().split("T")[1].slice(0, 12);
    const prefix = `%c[API ${timestamp}]`;
    const methodColor = this.getMethodColor(method);

    if (data !== undefined) {
      console.log(prefix, "color: #888", `%c${method}`, methodColor, endpoint, data);
    } else {
      console.log(prefix, "color: #888", `%c${method}`, methodColor, endpoint);
    }
  }

  public logResponse(method: string, endpoint: string, response: unknown, durationMs: number): void {
    if (!this.checkEnabled()) return;

    const timestamp = new Date().toISOString().split("T")[1].slice(0, 12);
    const prefix = `%c[API ${timestamp}]`;

    console.log(prefix, "color: #888", `%c${method}`, "color: #4CAF50", endpoint, `(${durationMs}ms)`, response);
  }

  public logError(method: string, endpoint: string, error: unknown, durationMs: number): void {
    if (!this.checkEnabled()) return;

    const timestamp = new Date().toISOString().split("T")[1].slice(0, 12);
    const prefix = `%c[API ${timestamp}]`;

    console.log(prefix, "color: #888", `%c${method}`, "color: #f44336", endpoint, `(${durationMs}ms)`, "ERROR:", error);
  }

  public enable(): void {
    localStorage.setItem(API_LOGGING_STORAGE_KEY, "true");
    this.isEnabled = true;
    console.log("[ApiLogger] Logging enabled");
  }

  public disable(): void {
    localStorage.removeItem(API_LOGGING_STORAGE_KEY);
    this.isEnabled = false;
    console.log("[ApiLogger] Logging disabled");
  }

  private getMethodColor(method: string): string {
    switch (method.toUpperCase()) {
      case "GET":
      case "FS:GET":
        return "color: #2196F3";
      case "POST":
      case "FS:POST":
        return "color: #4CAF50";
      case "PUT":
      case "PATCH":
      case "FS:PATCH":
        return "color: #FF9800";
      case "DELETE":
      case "FS:DELETE":
        return "color: #f44336";
      case "FS:SUB":
        return "color: #9C27B0";
      default:
        return "color: #9E9E9E";
    }
  }
}

export const apiLogger = new ApiLoggerService();
